// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"91":"1620c5e0","953":"1620c5e0"}[chunkId] + ".chunk.css";
};